import React, { useEffect } from 'react'

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEdit } from '@fortawesome/free-solid-svg-icons';

import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

// Services

// import {
//     clearConsultaListasInternas,
//     clearConsultaListasInternacionales, 
//     clearConsultaAlertaSafeWatch, 
//     clearInsertarClienteEnListaParaRevision 
//   } from "../../../../../store/lists/lists.actions";
//   import { clearConsultarClientesMisStore } from '../../../../../store/clients/clients.actions';
//   import { cleanUpClienteDataParcial } from '../../../../../store/forms/forms.actions';

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import Alert from '../../../../UI/Alert/Alert';
import TextInput from '../../../../UI/FormInput/TextInput';
import DropDownInput from '../../../../UI/FormInput/DropDownInput';
import MaskInput from '../../../../UI/FormInput/MaskInput';
import NumberInput from '../../../../UI/FormInput/NumberInput';
import CalendarInput from '../../../../UI/FormInput/CalendarInput';
import RadioInput from '../../../../UI/FormInput/RadioInput';
import FormInputGroup from '../../../../UI/FormInputGroup/FormInputGroup';
import Button from '../../../../UI/Button/Button';
import CurrencyInput from '../../../../UI/FormInput/CurrencyInput';

// Hooks

import GetStatesByCountry from '../../../../../hooks/GetStatesByCountry';
import GetCitiesByState from '../../../../../hooks/GetCitiesByState';
import GetCurrencyConversion from '../../../../../hooks/GetCurrencyConversion';

// Utilities

import { formatDropDownOptions, formatDropDownOptionsNationality, getCurrentDateMinusYears } from '../../../../../utilities/helper-functions';

// Constants

import { RIF_MASK_FORMAT, IDENTIFICATION_MASK_FORMAT, PASSPORT_MASK_FORMAT, DUE_DILIGENCE_SPECIAL_CATEGORIES, MAX_CURRENCY_INPUT_DIGITS } from '../../../../../config/constants';
import RepresentativeFields from '../RepresentativeFields';

export default function AboutYou({ formik, setShowEditNameModal }) {
    const { getStatesIsLoading, getStatesError, states, handleGetStatesByCountry } = GetStatesByCountry();
    const { getCitiesIsLoading, getCitiesError, cities, handleGetCitiesByState } = GetCitiesByState();
    const { getCurrencyConversionIsLoading, getCurrencyConversionError, currencyConversion, handleGetCurrencyConversion } = GetCurrencyConversion();

    // Dropdown Options
    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

    const dispatch = useDispatch();

    // Get States by Country

    useEffect(() => {
        if (formik.values?.cliente?.lugarNacimiento === '0') {
            handleGetStatesByCountry(formik.values?.cliente?.lugarNacimiento);
        }
    }, [formik.values?.cliente?.lugarNacimiento])

    // Get Cities by State

    useEffect(() => {
        if (formik.values?.cliente?.estadoNacimiento) {
            handleGetCitiesByState(formik.values?.cliente?.estadoNacimiento);
        }
    }, [formik.values?.cliente?.estadoNacimiento])


    // Get Relation Description by Code

    useEffect(() => {
        if ((formik.values?.cliente?.estadoCivil === 'C' || formik.values?.cliente?.estadoCivil === 'U')) {
            const code = formik.values?.cliente?.estadoCivil;
            const item = dropDownOptions?.data?.civilStatus?.find(
                (item) => item.value === code
            );
            formik.setFieldValue(`conyuge.nombreRelacion`, item?.name);
            formik.setFieldValue(`conyuge.codigoRelacion`, item?.value);
        }
    }, [formik.values?.estadoCivil]);


    // Get the Nationality Name

    useEffect(() => {
        if (formik.values?.cliente?.nacionalidad) {
            const code = formik.values?.cliente?.nacionalidad;
            const item = dropDownOptions?.data?.countries?.find((item) => item.value === code);
            formik.setFieldValue(`cliente.nombreNacionalidad`, item?.nationality);
        }
    }, [formik.values?.cliente?.nacionalidad])


    // Get the Birth City Name

    useEffect(() => {
        if (formik.values?.cliente?.ciudadNacimiento) {
            const code = formik.values?.cliente?.ciudadNacimiento;
            const item = cities?.find((item) => item.value === code);
            formik.setFieldValue(`cliente.nombreCiudadNacimiento`, item?.name);
        }
    }, [formik.values?.cliente?.ciudadNacimiento])


    // Setup and disable fields for minors

    useEffect(() => {
        if (formik.values?.cliente?.fechaNacimiento) {
            const currentDate = moment();
            const birthDate = moment(formik.values?.cliente?.fechaNacimiento);
            const dateDifference = currentDate.diff(birthDate, 'year');

            if (dateDifference < 18) {
                formik.setFieldValue(`cliente.esMenorDeEdad`, true);
                formik.setFieldValue(`cliente.estadoCivil`, 'S');
                formik.setFieldValue(`cliente.cargaFamiliar`, 0);
                // formik.setFieldValue(`cliente.tipoCliente`, '3');
                formik.setFieldValue(`hasApoderado`, 'no');
            } else {
                formik.setFieldValue(`cliente.esMenorDeEdad`, false);
            }
        }
    }, [formik.values?.cliente?.fechaNacimiento])


    // Set default specific activity for minor with document id

    useEffect(() => {
        if (formik.values?.cliente?.tipoCliente === '4' || formik.values?.cliente?.tipoCliente === '3') {
            formik.setFieldValue(`cliente.actividadEspecifica`, '91');
        }

        if (formik.values?.cliente?.tipoCliente === '5' || formik.values?.cliente?.tipoCliente === '6') {
            formik.setFieldValue(`cliente.actividadEconomica`, '080501');
            formik.setFieldValue(`cliente.actividadGeneradoraIngreso`, '5');
        }
    }, [formik.values?.cliente?.tipoCliente])


    // Set Currency Tipe Code

    useEffect(() => {
        if (formik.values?.cliente?.tipodeMonedaIngreso) {
            const code = formik.values?.cliente?.tipodeMonedaIngreso;
            const item = dropDownOptions?.data?.currencyTypes?.find((item) => item.value === code);
            formik.setFieldValue(`cliente.codigoMonedaIngreso`, item?.currency);
        }
    }, [formik.values?.cliente?.tipodeMonedaIngreso])


    // Set if the income amount is valid

    const handleSetIncomeAmountValid = (incomeIsValid) => {
        formik.setFieldValue(`cliente.incomeIsValid`, incomeIsValid);
    }

    return (
        <>
            <SectionHeading text={`${formik.values?.cliente?.nombre} ¡Queremos saber sobre ti!`} />

            <Alert text={'Estos datos son de vital importancia para comunicarnos contigo y ayudar a resolver cualquier duda o solicitud ¡Adelante!'} />

            {/* Edit Names and Document ID button */}

            {/* <div className='form-fields-edit-container'>
            <button 
                className='form-fields-edit-button' 
                onClick={() => {
                        dispatch(clearConsultarClientesMisStore());
                        dispatch(clearConsultaListasInternas());
                        dispatch(clearConsultaListasInternacionales());
                        dispatch(clearConsultaAlertaSafeWatch());
                        dispatch(clearInsertarClienteEnListaParaRevision());
                        dispatch(cleanUpClienteDataParcial());
                        setShowEditNameModal(true)
                    }
                } 
                type="button"
            >
                Editar nombres y documento
                <FontAwesomeIcon icon={faEdit} className='form-fields-edit-button-icon' />
            </button>
        </div> */}

            <FormInputGroup>

                <TextInput
                    formik={formik}
                    fieldName={'cliente.nombre'}
                    label={'Nombres'}
                    maxLength={42}
                    isRequired={true}
                    isAlphabetic
                    disabled
                />

                <TextInput
                    formik={formik}
                    fieldName={'cliente.primerApellido'}
                    label={'Primer Apellido'}
                    maxLength={20}
                    isRequired={true}
                    isAlphabetic
                    disabled
                />

                <TextInput
                    formik={formik}
                    fieldName={'cliente.segundoApellido'}
                    label={'Segundo Apellido'}
                    maxLength={20}
                    isAlphabetic
                    disabled
                />

                <CalendarInput
                    formik={formik}
                    fieldName={'cliente.fechaNacimiento'}
                    label={'Fecha de Nacimiento'}
                    minDate={getCurrentDateMinusYears(90)}
                    maxDate={getCurrentDateMinusYears(10)}
                    isRequired={true}
                    disabled
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.tipoDocumento'}
                    label={'Tipo de Identificación'}
                    options={formatDropDownOptions(dropDownOptions?.data?.identificationTypes)}
                    isRequired={true}
                    disabled
                />

                {(formik.values.cliente?.tipoDocumento && formik.values.cliente?.tipoDocumento !== 'P') &&
                    <MaskInput
                        formik={formik}
                        fieldName={'cliente.cedulaRif'}
                        label={'Número de Identificación'}
                        mask={IDENTIFICATION_MASK_FORMAT}
                        isRequired={true}
                        disabled
                    />}

                {formik.values.cliente?.tipoDocumento === 'P' &&
                    <MaskInput
                        formik={formik}
                        fieldName={'cliente.pasaporte'}
                        label={'Número de Pasaporte'}
                        mask={PASSPORT_MASK_FORMAT}
                        isRequired={true}
                        disabled
                    />}

                {formik.values.cliente?.tipoDocumento &&
                    <CalendarInput
                        formik={formik}
                        fieldName={'cliente.fechaExpedicionIdentificacion'}
                        label={'Fecha Expedición Identificación'}
                        maxDate={new Date()}
                        isRequired={true}
                        disabled
                    />}

                {formik.values.cliente?.tipoDocumento &&
                    <CalendarInput
                        formik={formik}
                        fieldName={'cliente.fechaVenceIdentificacion'}
                        label={'Fecha Vencimiento Identificación'}
                        minDate={formik.values.cliente?.tipoDocumento == 'P' ? new Date() : null}
                        isRequired={true}
                        disabled
                    />}

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.sexo'}
                    label={'Género'}
                    options={formatDropDownOptions(dropDownOptions?.data?.genders)}
                    isRequired={true}
                />

                {formik.values?.cliente?.fechaNacimiento && !formik.values?.cliente?.esMenorDeEdad &&
                    <>

                        <DropDownInput
                            formik={formik}
                            fieldName={`cliente.tipoRif`}
                            label={'Tipo RIF'}
                            options={formatDropDownOptions(dropDownOptions?.data?.identificationTypes)}
                            isRequired={true}
                            disabled={formik.values?.cliente?.esMenorDeEdad}
                        />

                        <MaskInput
                            formik={formik}
                            fieldName={`cliente.rif`}
                            label={'RIF'}
                            mask={formik.values.cliente?.tipoRif === 'P' ? PASSPORT_MASK_FORMAT : RIF_MASK_FORMAT}
                            isRequired={true}
                            disabled={formik.values?.cliente?.esMenorDeEdad}
                        />

                    </>}

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.nacionalidad'}
                    label={'Nacionalidad'}
                    options={formatDropDownOptionsNationality(dropDownOptions?.data?.nationalities)}
                    isRequired={true}
                    disabled
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.codigoOtraNacionalidad'}
                    label={'Otra Nacionalidad'}
                    options={formatDropDownOptionsNationality(dropDownOptions?.data?.nationalities)}
                    showClear
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.lugarNacimiento'}
                    label={'Lugar de Nacimiento'}
                    options={formatDropDownOptions(dropDownOptions?.data?.countries)}
                    isRequired={true}
                />

                {formik.values?.cliente?.lugarNacimiento === '0' &&
                    <DropDownInput
                        formik={formik}
                        fieldName={'cliente.estadoNacimiento'}
                        label={'Estado de Nacimiento'}
                        options={formatDropDownOptions(states)}
                        isRequired={true}
                        disabled={states?.length === 0 || getStatesIsLoading || getStatesError}
                        loading={getStatesIsLoading}
                    />}

                {formik.values?.cliente?.lugarNacimiento === '0' &&
                    <DropDownInput
                        formik={formik}
                        fieldName={'cliente.ciudadNacimiento'}
                        label={'Ciudad de Nacimiento'}
                        options={formatDropDownOptions(cities)}
                        isRequired={true}
                        disabled={cities?.length === 0 || getCitiesIsLoading || getCitiesError}
                        loading={getCitiesIsLoading}
                    />}

                <NumberInput
                    formik={formik}
                    fieldName={'cliente.cargaFamiliar'}
                    label={'Carga familiar'}
                    isRequired={true}
                    disabled={!formik.values?.cliente?.fechaNacimiento || formik.values?.cliente?.esMenorDeEdad}
                    max={999}
                    min={0}
                    maxLength={3}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.estadoCivil'}
                    label={'Estado Civil'}
                    options={formatDropDownOptions(dropDownOptions?.data?.civilStatus)}
                    isRequired={true}
                    // disabled={!formik.values?.cliente?.fechaNacimiento || formik.values?.cliente?.esMenorDeEdad}
                    disabled={true}
                />

            </FormInputGroup>

            {((formik.values.cliente?.estadoCivil === 'C' || formik.values.cliente?.estadoCivil === 'U')) &&
                <>
                    <SectionHeading text={'Datos del conyugue'} hideRequiredFieldsMessage />

                    <FormInputGroup>

                        <TextInput
                            formik={formik}
                            fieldName={'conyuge.nombre'}
                            label={'Nombres'}
                            maxLength={42}
                            isRequired={true}
                            isAlphabetic
                        />

                        <TextInput
                            formik={formik}
                            fieldName={'conyuge.primerApellido'}
                            label={'Primer Apellido'}
                            maxLength={20}
                            isRequired={true}
                            isAlphabetic
                        />

                        <TextInput
                            formik={formik}
                            fieldName={'conyuge.segundoApellido'}
                            label={'Segundo Apellido'}
                            maxLength={20}
                            isAlphabetic
                        />

                        <DropDownInput
                            formik={formik}
                            fieldName={'conyuge.tipoDocumento'}
                            label={'Tipo de Identificación'}
                            options={formatDropDownOptions(dropDownOptions?.data?.identificationTypes)}
                            isRequired={true}
                        />

                        {(formik.values.conyuge?.tipoDocumento && formik.values.conyuge?.tipoDocumento !== 'P') &&
                            <MaskInput
                                formik={formik}
                                fieldName={'conyuge.cedulaRif'}
                                label={'Número de Identificación'}
                                mask={IDENTIFICATION_MASK_FORMAT}
                                isRequired={true}
                            />}

                        {formik.values.conyuge?.tipoDocumento === 'P' &&
                            <MaskInput
                                formik={formik}
                                fieldName={'conyuge.pasaporte'}
                                label={'Número de Pasaporte'}
                                mask={PASSPORT_MASK_FORMAT}
                                isRequired={true}
                            />}

                        {formik.values.conyuge?.tipoDocumento &&
                            <CalendarInput
                                formik={formik}
                                fieldName={'conyuge.fechaVenceIdentificacion'}
                                label={'Fecha Vencimiento Identificación'}
                                minDate={formik.values.conyuge?.tipoDocumento == 'P' ? new Date() : null}
                                isRequired={true}
                            />}

                        <DropDownInput
                            formik={formik}
                            fieldName={'conyuge.fuenteOrigen'}
                            label={'Fuente de ingresos del conyuge'}
                            options={formatDropDownOptions(dropDownOptions?.data?.sourceOfFunds)}
                            isRequired={true}
                        />

                    </FormInputGroup>
                </>}

            {/* {['1', '2', '5', '6'].includes(formik.values?.cliente?.tipoCliente) && */}
            <RadioInput
                formik={formik}
                fieldName={'hasApoderado'}
                label={'¿Posees un autorizado o apoderado?'}
                options={[{ label: 'Sí', value: 'si' }, { label: 'No', value: 'no' }]}
                isGroup={true}
                isRequired={true}
                disabled={!formik.values?.cliente?.fechaNacimiento || formik.values?.cliente?.esMenorDeEdad}
            />
            {/* } */}

            {formik.values?.hasApoderado === 'si' &&
                <RepresentativeFields
                    formik={formik}
                    dropDownOptions={dropDownOptions}
                />}

            <SectionHeading text={'Cuéntanos a qué te dedicas'} hideRequiredFieldsMessage />

            <FormInputGroup>

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.tipoCliente'}
                    label={'Condición de cliente'}
                    options={formatDropDownOptions(dropDownOptions?.data?.customerTypes)}
                    isRequired={true}
                    disabled
                />

                {['1', '2', '6'].includes(formik.values?.cliente?.tipoCliente) &&
                    <DropDownInput
                        formik={formik}
                        fieldName={'cliente.caracteristicaCliente'}
                        label={'Caracteristicas del Cliente'}
                        options={formatDropDownOptions(dropDownOptions?.data?.customerFeatures)}
                        isRequired={true}
                    />}

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.profesion'}
                    label={'Profesión'}
                    options={formatDropDownOptions(dropDownOptions?.data?.professions)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.actividadEspecifica'}
                    label={'Actividad Específica'}
                    options={formatDropDownOptions(dropDownOptions?.data?.specificActivities)}
                    isRequired={true}
                    // disabled={formik.values?.cliente?.tipoCliente === '4'}
                    disabled={!formik.values?.cliente?.fechaNacimiento}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.actividadEconomica'}
                    label={'Actividad Economica'}
                    options={formatDropDownOptions(dropDownOptions?.data?.economicActivities)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.categoriaEspecial'}
                    label={'Categoria Especial'}
                    options={formatDropDownOptions(dropDownOptions?.data?.specialCategories)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.nivelAcademico'}
                    label={'Nivel Académido'}
                    options={formatDropDownOptions(dropDownOptions?.data?.academicLevels)}
                    isRequired={true}
                />

                {/* Declaración Jurada de Ingreso */}

                {['5', '6'].includes(formik.values?.cliente?.tipoCliente) &&
                    <>
                        <DropDownInput
                            formik={formik}
                            fieldName={'cliente.actividadGeneradoraIngreso'}
                            label={'Actividad Generadora de Ingreso'}
                            options={formatDropDownOptions(dropDownOptions?.data?.otherIncomes)}
                            isRequired={true}
                        />

                        <CalendarInput
                            formik={formik}
                            fieldName={'cliente.fechaDesdeCuandoRecibeIngreso'}
                            label={'Fecha desde cuando recibe ingresos'}
                            maxDate={new Date()}
                            isRequired={true}
                        />

                        <DropDownInput
                            formik={formik}
                            fieldName={'cliente.tipodeMonedaIngreso'}
                            label={'Tipo de Moneda'}
                            options={formatDropDownOptions(dropDownOptions?.data?.currencyTypes)}
                            isRequired={true}
                            additionalFunctions={() => formik.setFieldValue('cliente.incomeIsValid', null)}
                        />

                        <CurrencyInput
                            formik={formik}
                            fieldName={'cliente.montoEstimadoDeIngreso'}
                            label={'Monto estimado de ingreso'}
                            isRequired={true}
                            max={MAX_CURRENCY_INPUT_DIGITS}
                            additionalFunctions={() => formik.setFieldValue('cliente.incomeIsValid', null)}
                        />

                        <TextInput
                            formik={formik}
                            fieldName={'cliente.descripcionDeIngreso'}
                            label={'Descripción de ingreso'}
                            isRequired={true}
                        />
                    </>}


                {['5', '6'].includes(formik.values?.cliente?.tipoCliente) &&
                    <>

                        {formik.values?.cliente?.incomeIsValid === true &&
                            <Alert text={'Monto y moneda de Ingreso validados exitosamente'} />}

                        {getCurrencyConversionError &&
                            <p className="form-error-message">Ocurrió un error al validar el ingreso. Por favor reintente.</p>}

                        {formik.values?.cliente?.incomeIsValid === false &&
                            <p className="form-error-message">El monto introducido excede el máximo para su condición de cliente. Por favor elija Trabajador Dependiente o Independiente.</p>}

                        {formik.values?.cliente?.incomeIsValid !== true &&
                            <div>

                                <Button
                                    type="button"
                                    action={() => handleGetCurrencyConversion(
                                        {
                                            currency_code: formik.values?.cliente?.tipodeMonedaIngreso,
                                            amount: String(formik.values?.cliente?.montoEstimadoDeIngreso),
                                        },
                                        handleSetIncomeAmountValid,
                                        dropDownOptions?.data?.CurrencyTypeMinimumAmounts
                                    )}
                                    label={'Validar ingresos'}
                                    additionalStyles={{ marginLeft: 0, marginBottom: '2rem', padding: '0.75rem 1.5rem' }}
                                    isLoading={getCurrencyConversionIsLoading}
                                    disabled={
                                        !formik.values?.cliente?.montoEstimadoDeIngreso ||
                                        !formik.values?.cliente?.tipodeMonedaIngreso
                                    }
                                />

                                <span>Por favor ingrese el tipo de moneda y monto estimado para validar.</span>

                            </div>}

                            {formik.errors?.cliente?.incomeIsValid &&
                            <p className="form-error-message">{formik.errors?.cliente?.incomeIsValid}</p>}

                    </>}

            </FormInputGroup>


            {/* Due Diligence Questionnaire */}

            {DUE_DILIGENCE_SPECIAL_CATEGORIES?.includes(formik?.values?.cliente?.categoriaEspecial) &&
                <div className='due-giligencie-questionarie'>

                    <SectionHeading text={'Cuestionario de Debida Diligencia para la Verificación del Cumplimiento de las Disposiciones Contenidas en las Leyes y Normas Nacionales e Internacionales en Materia de PC/LC/FT/FPADM y Cualquier Delito Previsto en ellas - Persona Natural'} hideRequiredFieldsMessage />

                    <div className='due-giligencie-questionarie-text'>

                        <p>Considerando su actividad económica y lo previsto en la normativa legal vigente en materia de delincuencia organizada, legitimación de capitales, financiamiento al terrorismo, financiamiento a la proliferación de armas de destrucción masiva, y de cualquier otro delito tipificado en esas normas nacionales e internacionales, y en aras de velar por la adecuada y efectiva prevención de los riesgo asociados al hecho de ser utilizado como medio para la comisión de los delitos indicados anteriormente, usted posee algunas políticas, normas y procedimientos para:</p>

                        <ul>
                            <li>Adoptar, desarrollar y ejecutar normas, procedimientos, y controles para prevenir la legitimación de capitales, financiamiento al terrorismo, financiamiento de la proliferación de armas de destrucción masiva, que le permitan mitigar los riesgos de ser utilizado como mecanismo para legitimar capitales provenientes de actividades ilícitas o financiar cualquier delito tipificado en las normativas legales vigentes. </li>
                            <li>Prestar especial atención y cumplir con las obligaciones establecidas en las normativas legales vigentes que se encuentren previsto nacional e internacionalmente en materia de prevención y control de legitimación de capitales, financiamiento al terrorismo, financiamiento a la proliferación de armas de destrucción masiva, y de cualquier otro delito tipificado en las normativas venezolanas. Asimismo, prestar especial atención a tales actividades aún cuando provengan de una fuente lícita.</li>
                            <li>Establecer mecanismos que permitan detectar cualquier situación y/o transacción inusual o sospechosa, aún cuando éstas tengan una justificación económica aparente o visible.</li>
                            <li>Cumplir con la obligación de no iniciar o mantener relaciones económicas, con personas naturales o jurídicas cuya identidad no pueda ser determinada plenamente.</li>
                            <li>Cualquier acción que le permita evidenciar el cumplimiento de lo exigido en la normativa legal vigente para la actividad que desempeña y que lo obliga a establecer políticas, normas y procedimientos en materia de Prevención y Control de Legitimación de Capitales, Financiamiento al Terrorismo, Financiamiento a la Proliferación de Armas de Destrucción Masiva.</li>
                        </ul>

                        <div className='due-giligencie-questionarie-input'>
                            <RadioInput
                                formik={formik}
                                fieldName={'dueDiligence'}
                                options={[{ label: 'Sí', value: 'Si' }, { label: 'No', value: 'No' }]}
                                isGroup={true}
                            />
                        </div>

                        <p><strong>Declaro expresamente en mi condición de Sujeto Obligado y que se encuentra dispuesto en las leyes nacionales, mi identificación y apego a los principios y valores éticos establecidos en BANCARIBEC.A. Banco Universal, en materia de PCLC/FT/FPADM, para mitigar los riesgos que generaría el uso de los servicios y productos de esta institución financiera como instrumento de Legitimación de Capitales, Financiamiento al Terrorismo, Financiamiento a la Proliferación de Armas de Destrucción Masiva y de cualquier otro delito tipificado, según se ha dado respuesta, a este cuestionario.</strong></p>

                    </div>

                </div>}

            <div className='form-actions'>

                <Button
                    type="submit"
                    action={formik.handleSubmit}
                    label={'Continua'}
                />

            </div>
        </>
    )
}
